<template>

  <div :id="agency ? 'agency-outer' : ''">

    <div v-if="agency" :class="agency ? 'agency' : ''">
      <div class="agency-label">
        <span>{{ agency.Ad }}</span>
      </div>
    </div>

    <header>
      <div class="inner">
        <div class="logo"><a href="/">AXA Sigorta</a></div>
        <div v-if="$props.step" class="steps">
          <div class="item" :class="$props.step === 1 ? 'active' : ''">
            <div class="info">
              <a>
                <div class="number">1</div>
                <div class="name">BİLGİLER</div>
              </a>
            </div>
          </div>
          <div class="item" :class="$props.step === 2 ? 'active' : ''">
            <div class="info">
              <a>
                <div class="number">2</div>
                <div class="name">SONUÇ</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section>
      <div class="inner">
        <div v-if="!store.error" :class="$props.contentClass + '-content'">
          <div v-if="$props.pageTitle" class="title">
            <div v-if="$props.pageTitleIcon" class="icon">
              <img alt="AXA Dijital Sağlık Sigortası Fiyat Teklifi Al" :src="require('@/assets/images/icon/' +
                $props.pageTitleIcon +
                '.png')
                " />
            </div>
            <h1>{{ $props.pageTitle }}</h1>
            <h2 v-if="$props.pageSubtitle">{{ $props.pageSubtitle }}</h2>
          </div>
          <slot></slot>
        </div>
        <div class="general-content" v-if="store.error">
          <ErrorMessage />
        </div>
      </div>
      <div v-if="$props.bgImg" class="fixed-bg" :style="{
        'background-image':
          'url(' +
          require('@/assets/images/bg/' + $props.bgImg + '.jpg') +
          ')',
      }"></div>
      <div v-if="$props.fixedPhone" class="fixed-phone">
        <a href="tel:08502509999">0850 250 99 99</a>
      </div>
    </section>

    <div v-if="$props.loading" class="page-loading">
      <div class="page-loading-icon">
        <i class="fas fa-spinner fa-pulse"></i>
      </div>
    </div>

    <LegalNoticePopup />
  </div>
</template>

<script>
import { store } from "@/store";
import service from "@/utils/service";

const newService = new service();

export default {
  props: {
    methods: {
      onClose() {
        this.$emit("close");
      },
    },
    contentClass: {
      type: String, // general - special
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageTitleIcon: {
      type: String,
    },
    pageSubtitle: {
      type: String,
    },
    step: {
      type: Number,
    },
    loading: {
      type: Boolean,
    },
    bgImg: {
      type: String,
    },
    fixedPhone: {
      type: Boolean,
    },
  },
  data() {
    return {
      store,
      agency: null,
    };
  },
  async created() {
    this.agency = await newService.GetWebAcenteAccessList();
    store.acenteNo = await this.agency?.Acente_No;
  },
};


</script>
<style>
.agency-label {
  width: 400px;
  font-size: 18px;
  font-weight: 600;
  color: #00008f;
  position: fixed;
  left: 30px;
  top: 128px;
  z-index: 3;
}

.agency-label span {
  display: block;
  width: 100%;
  padding: 15px;
  background: hsla(0, 0%, 100%, 0.5);
  border-radius: 10px;
}

@media (max-width: 1200px) {
  .container {
    width: auto;
    padding: 0 15px;
  }

  .agency-label {
    width: 270px;
    left: 15px;
  }
}

@media (max-width: 991px) {
  #agency-outer {
    padding: 90px 0 30px 0;
  }

  #agency-outer section {
    padding: 30px 0;
  }

  .agency-label {
    width: 100%;
    position: relative;
    top: auto;
    left: auto;
    font-size: 16px;
    padding: 0 15px;
    margin-top: 15px;
  }
}
</style>